export const navigationItems = [
  { label: 'Home', path: '/' },
  { label: 'About', path: '/about' },
  {
    label: 'Our Services',
    children: [
      { label: 'DevX Factor', path: '/services/devxfactor' },
      { label: 'SatyamCode', path: '/services/satyamcode' },
      { label: 'PhysicsFactor', path: '/services/physicsfactor' },
      { label: 'SatyamSir', path: '/services/satyamsir' },
    ],
  },
  {
    label: 'Career',
    children: [
      { label: 'Current Openings', path: '/jobs' },
      { label: 'Hiring Process', path: '/hiring-process' },
      { label: 'Apply Now', path: '/apply' },
    ],
  },
  { label: 'Contact', path: '/contact' },
];
